import { cn } from "@/lib/utils/cn";

/** A single animated placeholder block. Callers size it via className
 * (height/width utilities) - this component has no intrinsic size of its own. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded-md bg-primary-100", className)} />;
}
